var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#DCEAF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7164 26.8291H29.6084L31.8914 32.2801H12.1094L14.3924 26.8281H16.2844",
    fill: "#DCEAF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7164 26.8291H29.6084L31.8914 32.2801H12.1094L14.3924 26.8281H16.2844",
    stroke: "#5A7994",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.215 29.135C22.215 29.135 29.429 23.724 29.429 18.899C29.43 15.156 26.724 12 22.215 12C17.705 12 15 15.156 15 18.899C15 23.724 22.215 29.135 22.215 29.135Z",
    stroke: "#5A7994",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4688 16.5H23.9688V20H20.4688V16.5Z",
    stroke: "#5A7994",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.17d53b2a652de07d0681973aa77004bc.svg";
export { ForwardRef as ReactComponent };